module.exports = "/_next/static/images/5f69cc49c4d2dc42f26b21d29816b1fb-sequoia.png.webp";